import { render, staticRenderFns } from "./KeapMarketingSmsTemplateItem.vue?vue&type=template&id=3b453f22"
import script from "./KeapMarketingSmsTemplateItem.vue?vue&type=script&lang=js"
export * from "./KeapMarketingSmsTemplateItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports